import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { SignInStatus } from '../../../core/enums/sign-in-status.enum';
import { IVerificationUser } from '../../../core/interfaces/login/verification.interface';
import { LoginService } from '../../../core/services/login/login.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['verification.component.scss'],
})
export class VerificationComponent implements OnInit, OnDestroy {
  myform: FormGroup;
  questionText: string;
  questionId: number;
  answer: string;
  subscriptions: Subscription[] = [];

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private lg: LoginService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.http
        .get('https://dev2.nowaccount.com/OnBoarding/Login/Verification')
        .subscribe((result: any) => {
          this.questionText = result.QuestionText;
          this.questionId = result.UserSecurityQuestionId;
        })
    );

    this.myform = this.fb.group({
      answer: '',
    });
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  submitForm() {
    const body: IVerificationUser = {
      AnswerText: this.myform.get('answer')?.value ?? '',
      UserSecurityQuestionId: this.questionId,
    };

    this.subscriptions.push(
      this.lg.verification(body).subscribe((result: any) => {
        if (result === SignInStatus.Success) {
          this.redirecttoHome();
        }
      })
    );
  }

  redirecttoHome() {
    window.location.href = 'https://dev2.nowaccount.com/';
  }
}
